module.exports = __webpack_public_path__ + "img/peel_3.f666b742.jpg";